import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import {
  confirmForm,
  editForm,
  ADDITIONAL_COVERAGES_FORM,
} from '../Actions/actions';
import { formName } from '../Constants/constants';
import AdditionalCoverages from '../Components/AdditionalCoverages/AdditionalCoverages';

const formValues = formValueSelector(formName);

const mapStateToProps = (state) => ({
  enabled: state.formPage.additionalCoverages.enabled,
  confirmed: state.formPage.additionalCoverages.confirmed,
  valid: state.formPage.additionalCoverages.valid,
  liquorPrice: state.formPage.priceValues.liquor,
  damageToRentedPropertyPrice:
    state.formPage.priceValues.damageToRentedProperty,
  sellingLiquor: formValues(state, 'ACSellingLiquor'),
  damageToRentedProperty: formValues(state, 'ACDamageToRentedProperty'),
  personalPropertyHide:
    state.formPage.additionalCoverages.personalPropertyStatus.hide,
  hostLiquorHide: state.formPage.additionalCoverages.hostLiquorStatus.hide,
  liquorLiabilityHide:
    state.formPage.additionalCoverages.liquorLiabilityStatus.hide,
  terrorismHide: state.formPage.additionalCoverages.terrorismStatus.hide,
  damageToRentedPropertyHide:
    state.formPage.additionalCoverages.damageToRentedPropertyStatus.hide,
  personalPropertyMandatory:
    state.formPage.additionalCoverages.personalPropertyStatus.mandatory,
  hostLiquorMandatory:
    state.formPage.additionalCoverages.hostLiquorStatus.mandatory,
  liquorLiabilityMandatory:
    state.formPage.additionalCoverages.liquorLiabilityStatus.mandatory,
  terrorismMandatory:
    state.formPage.additionalCoverages.terrorismStatus.mandatory,
  damageToRentedPropertyMandatory:
    state.formPage.additionalCoverages.damageToRentedPropertyStatus.mandatory,
});

const mapDispatchToProps = (dispatch) => ({
  edit: () => dispatch(editForm(ADDITIONAL_COVERAGES_FORM)),
  confirm: () => dispatch(confirmForm(ADDITIONAL_COVERAGES_FORM)),
});

const AdditionalCoveragesContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdditionalCoverages);

export default AdditionalCoveragesContainer;
